import { render, staticRenderFns } from "./ModalPagamentos.vue?vue&type=template&id=797a6c1a&"
import script from "./ModalPagamentos.vue?vue&type=script&lang=js&"
export * from "./ModalPagamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports